import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';

export const REQUEST_STUDENTS = 'REQUEST_STUDENTS';
export const RECEIVE_STUDENTS = 'RECEIVE_STUDENTS';
export const STUDENTS_ERROR = 'STUDENTS_ERROR';

export const fetchStudents = () => async (dispatch) => {
    dispatch({ type: REQUEST_STUDENTS });
    const payload = {
        orgId: localStorage.getItem('orgId'),
        academicYear: localStorage.getItem('userAcademicYear')
    };
    const url = `${baseUrlAdmin}/students/student-information`;
    try {
        const service = new Service();
        const response = await service.post(url, payload, true);
        if (response?.status && response?.res?.status) {
            dispatch({ type: RECEIVE_STUDENTS, students: response.res.data.data });
        } else {
            dispatch({ type: STUDENTS_ERROR, error: 'No data' });
        }
    } catch (error) {
        dispatch({ type: STUDENTS_ERROR, error: error.message });
    }
};